import { render, staticRenderFns } from "./Konumlar.vue?vue&type=template&id=0202fb1a&scoped=true&"
import script from "./Konumlar.vue?vue&type=script&lang=js&"
export * from "./Konumlar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0202fb1a",
  null
  
)

export default component.exports